module.exports = __webpack_public_path__ + "media/images/logo-048fb522.png";